// window.__env__ is used in deployed to kube projects
// process.env is used during local development
let envSource;

if (process.env.NODE_ENV === 'development') {
    envSource = process.env;
} else {
    envSource = window.__env__;
}

const {
    REACT_APP_ZERO_KCELL_URL,
    REACT_APP_CONFIG: CONFIG,
} = envSource;

const config = {
    CONFIG,
    zeroKcellUrl: REACT_APP_ZERO_KCELL_URL,
};

export default config;